import React from 'react'
import { Grid } from '../../../../components/Reusable/Grid'
import { Column, Row, Header } from './Soc2ReportModal.styles'

export function Soc2ReportModal(): JSX.Element {
  return (
    <>
      <p>Your data will appear directly in the pro forma SOC 2 report.</p>
      <Grid gridTemplateColumns="repeat(3, auto)" mt="xl">
        <Row>
          <Header>Your Input to Trustero</Header>
          <Header />
          <Header>Corresponding Section in SOC 2</Header>
        </Row>
        <Row>
          <Column>
            <strong>{'Services: '}</strong>
            Your Critical Vendors
          </Column>
          <Column>➝</Column>
          <Column>
            <strong>{'Section III: '}</strong>
            Description of Services
          </Column>
        </Row>
        <Row>
          <Column>
            <strong>{'Company Info: '}</strong>
            Company Info and Vendors
          </Column>
          <Column>➝</Column>
          <Column>
            <strong>{'Section III: '}</strong>
            Description of Services
          </Column>
        </Row>
        <Row>
          <Column>
            <strong>{'Controls: '}</strong>
            Tests and Results
          </Column>
          <Column>➝</Column>
          <Column>
            <strong>{'Section IV: '}</strong>
            Description of Criteria, Controls, Tests, and Results
          </Column>
        </Row>
      </Grid>
    </>
  )
}
